export const MEDIIIA_BOTTOM_MENU_HEIGHT = 77;export const MEDIIIA_BOTTOM_MENU_HEIGHT = 77;